import Styles from "./Button.module.css";

function Button({ text }) {
    return <button className={Styles.btncustom}>{text}</button>;
}

export default Button;
